import { render } from "./customizercolor.vue?vue&type=template&id=014eae3a"
import script from "./customizercolor.vue?vue&type=script&lang=js"
export * from "./customizercolor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__